import React from 'react';
import cls from 'classnames';
import { Input } from 'antd';

const InputComponent = React.forwardRef((
  {
    placeholder,
    onChange,
    className,
    ...props
  }, ref) => {


  return (
    <Input placeholder={placeholder}
           onChange={onChange}
           className={cls(className, 'input')}
           ref={ref || null}
           {...props}
    />
  );
});

export default InputComponent;
